import { Header, addWithConfig } from '@rbilabs/universal-components';

import ActionButton from 'components/action-button';
import { ModalContent as OriginalModalContent } from 'components/modal';
import { primitive } from 'styles/constants';

import { ADDRESS_MODAL_WIDTH_DESKTOP } from './constants';

export const ModalContent = OriginalModalContent.withConfig({
  width: { base: 'full', md: ADDRESS_MODAL_WIDTH_DESKTOP },
  paddingX: { base: '$3', md: '$0' },
  alignSelf: 'center',
});

export const ModalTitle = Header.withConfig({
  variant: 'headerTwo',
  textAlign: 'center',
});

export const DeliverHereButton = addWithConfig(ActionButton).withConfig({
  fullWidth: true,
  borderWidth: 0,
  color: primitive.$white,
  mb: '$4',
  _disabled: {
    bg: primitive.$fieryRedOpacity30,
    color: primitive.$white,
    opacity: 1,
    borderWidth: 0,
  },
  _text: {
    fontSize: 'lg',
    color: primitive.$white,
  },
  _loading: {
    bg: primitive.$fieryRedOpacity30,
    borderWidth: 0,
    borderColor: primitive.$bbqBrown,
  },
});
